
import React from 'react';
// import LoadingDots from '../../common/Loader/LoadingDots';

const ButtonBlack = ({ 
  children, 
  onClick, 
  type = 'button', 
  className = '', 
  style1 = "px-6 py-2", 
  disabled = false, 
  icon = "", 
  radius = "md", 
  isLoading = false,
  DefaultClassName = "px-6 py-2 rounded-md",
}) => {

  // Déterminer les classes selon l'état
  let buttonClass = `flex items-center justify-center gap-x-2 text-sm rounded-${radius} focus:outline-none focus:ring-2 focus:ring-neutral-300 transition duration-150 ${style1}`;

  if (isLoading) {
    buttonClass += " bg-black/70 shadow border-gray-400 border text-white opacity-70 py-2 px-4 cursor-not-allowed";
  } else if (disabled) {
    buttonClass += " bg-gray-300 shadow-md text-gray-500 cursor-not-allowed";
  } else {
    buttonClass += " bg-black hover:bg-black/80 text-white";
  }

  return (
<button
  type={type}
  onClick={onClick}
  disabled={disabled || isLoading}
  className={`${buttonClass} ${className || DefaultClassName}`}
  style={{ minWidth: "120px", height: "40px" }} // Ajuste selon tes besoins
>
  {isLoading ? (
    <svg className="loading-svg" viewBox="25 25 50 50">
      <circle className="loading-circle-svg" r="20" cy="50" cx="50"></circle>
    </svg>
  ) : (
    <span className={isLoading ? "invisible" : "visible"}>{children}</span>
  )}
</button>

  );
};

export default ButtonBlack;

// import React from 'react'
// import img1 from "../../plateform/assets/icons/icons8-loading-30.png"

// const ButtonBlack  = ({ children, onClick, type = 'button', DefaultClassName = "px-6 py-2 rounded-md", disabled=false , isLoading =true}) => {
//   return (
//     <button
//       type={type}
//       onClick={onClick}
//       disabled={disabled}
//       className={!disabled?`bg-primary-black hover:bg-primary-black/90 text-white flex items-center justify-center   focus:outline-none focus:ring-1 focus:ring-neutral-200 text-sm ${DefaultClassName} `:`bg-neutral-300 text-white px-6 py-2 rounded-md  focus:outline-none focus:ring-2 focus:ring-orange-300 text-sm cursor-not-allowed flex items-center justify-center  ${DefaultClassName} `+` text-white   focus:outline-none focus:ring-1 focus:ring-neutral-200 text-sm ${DefaultClassName}`}
//     >
//       {isLoading ?
//       <svg class="loading-svg" viewBox="25 25 50 50">
//       <circle  class="loading-circle-svg" r="20" cy="50" cx="50"></circle>
//     </svg>
//       : children}
//     </button>
//   );
// };

// export default ButtonBlack